function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$5 } from './avatar.js';
import { d as defineCustomElement$4 } from './flex.js';
import { d as defineCustomElement$3 } from './icon.js';
import { d as defineCustomElement$2 } from './text.js';
var UserDetail = /*@__PURE__*/proxyCustomElement( /*#__PURE__*/function (_HTMLElement) {
  _inherits(UserDetail, _HTMLElement);

  var _super = _createSuper(UserDetail);

  function UserDetail() {
    var _this;

    _classCallCheck(this, UserDetail);

    _this = _super.call(this);

    _this.__registerHost();

    _this.user = undefined;
    return _this;
  }

  _createClass(UserDetail, [{
    key: "render",
    value: function render() {
      return h("skp-flex", {
        justifyContent: 'flex-start',
        gap: 3
      }, h("skp-avatar", {
        size: 'large',
        feeling: this.user.feeling,
        src: this.user.picture,
        name: this.user.name
      }), h("skp-flex", {
        flexDirection: 'column',
        gap: 0
      }, h("skp-text", {
        size: 'large',
        bold: true,
        text: this.user.name
      }), !!this.user.mail && h("skp-text", {
        size: 'xsmall',
        italic: true,
        text: this.user.mail
      }), !!this.user.credit && h("skp-text", {
        size: 'small',
        text: "".concat(this.user.credit.toString(), " credits"),
        color: '--skp-color-success-500'
      })));
    }
  }]);

  return UserDetail;
}(HTMLElement), [0, "skp-user-detail", {
  "user": [16]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["skp-user-detail", "skp-avatar", "skp-flex", "skp-icon", "skp-text"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "skp-user-detail":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, UserDetail);
        }

        break;

      case "skp-avatar":
        if (!customElements.get(tagName)) {
          defineCustomElement$5();
        }

        break;

      case "skp-flex":
        if (!customElements.get(tagName)) {
          defineCustomElement$4();
        }

        break;

      case "skp-icon":
        if (!customElements.get(tagName)) {
          defineCustomElement$3();
        }

        break;

      case "skp-text":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }

        break;
    }
  });
}

var SkpUserDetail = UserDetail;
var defineCustomElement = defineCustomElement$1;
export { SkpUserDetail, defineCustomElement };